import React from 'react';
import ContactBlock from './ContactBlock';

const Contact = () => (
  <ContactBlock
    standalone
    showSubject
    title="Let's talk."
    lede="Tell us about your business and what you're trying to accomplish. No technical knowledge required — just describe the problem you need solved."
  />
);

export default Contact;
